import { useCallback, useState } from 'react';
import { useMqttSubscription } from './useMqttSubscription';

const RFID_REQUEST_PREFIX = 'rfid_request,';
const RFID_CODE_PREFIX = 'rfidCode,';

// Listens for an RFID scan on a unit's status and config topics. Only active
// while `enabled` is true, so the connection opens when the read starts and
// closes once the caller stops listening (e.g. the modal is closed).
// Subscribes with a wildcard for the device segment (matches the convention used
// for other response topics, e.g. getSensorSettings), since the publishing device
// on this topic isn't guaranteed to match devices.displayID.
// Payloads are base64-encoded by the device, same as other config/status messages.
export const useRfidReader = (unitId, enabled) => {
  const [uuid, setUuid] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  const topics = enabled && unitId ? [`${unitId}/+/status`, `${unitId}/+/config`] : [];

  const handleMessage = useCallback((_topic, payload) => {
    let text;
    try {
      text = atob(payload.toString());
    } catch {
      text = payload.toString();
    }
    if (text.startsWith(RFID_REQUEST_PREFIX)) {
      setUuid(text.slice(RFID_REQUEST_PREFIX.length).trim());
    } else if (text.startsWith(RFID_CODE_PREFIX)) {
      try {
        setUserInfo(JSON.parse(text.slice(RFID_CODE_PREFIX.length)));
      } catch (err) {
        console.error('Failed to parse rfidCode payload:', err);
      }
    }
  }, []);

  const { isConnected } = useMqttSubscription(topics, handleMessage);

  const reset = useCallback(() => {
    setUuid(null);
    setUserInfo(null);
  }, []);

  return { uuid, userInfo, isConnected, reset };
};
